import { render, staticRenderFns } from "./AddOrUpdateDrugModal.vue?vue&type=template&id=2e069e25&"
import script from "./AddOrUpdateDrugModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateDrugModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateDrugModal.vue?vue&type=style&index=0&id=2e069e25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports